<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <section>
        <fieldset class="tw-py-30px">
          <legend>
            {{ pageVocabs + "legend" | translate }}
          </legend>

          <div class="row">
            <!-- privateNumberId -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <public-receive-keyword-select-search
                *ngIf="!this.formPageConfig.isEditMode"
                [isDisabled]="formPageConfig.isEditMode"
                [isShowRefreshBtn]="true"
                [control]="form?.get('privateNumberId')"
                [(value)]="model.privateNumberId"
                (onError)="onClose()"
              >
              </public-receive-keyword-select-search>

              <form-field
                *ngIf="this.formPageConfig.isEditMode"
                [(value)]="this.formPageConfig.editData.privateNumber"
                [control]="form?.get('privateNumber')"
                label="common.privateNumber"
              >
              </form-field>
            </div>

            <!-- organizations -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <organization-select-search
                *ngIf="!this.formPageConfig.isEditMode"
                type="descendantList"
                [isDisabled]="formPageConfig.isEditMode"
                [control]="form?.get('organizationId')"
                [(value)]="model.organizationId"
                (onError)="onClose()"
              >
              </organization-select-search>

              <form-field
                *ngIf="this.formPageConfig.isEditMode"
                [(value)]="this.formPageConfig.editData.organizationName"
                [control]="form?.get('organizationName')"
                label="common.organization"
              >
              </form-field>
            </div>

            <!-- useType -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <enum-select-search
                class="tw-w-full"
                enumName="UseTypes"
                label="common.useType"
                [control]="form?.get('useType')"
                [(value)]="model.useType"
                (onError)="onClose()"
              >
              </enum-select-search>
            </div>

            <!-- keyword -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.keyword"
                [control]="form?.get('keyword')"
                label="common.keyword"
              >
              </form-field>
            </div>

            <!-- price -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                type="tel"
                [hasNumberSeparator]="true"
                [control]="form?.get('price')"
                [(value)]="model.price"
                [hasCurrency]="true"
                label="common.price"
              >
              </form-field>
            </div>

            <!--expireDate-->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <datepicker
                [isEdit]="formPageConfig.isEditMode"
                [value]="model.expireDate"
                label="common.expireDate"
                (value)="model.expireDate = $event"
                [control]="form?.get('expireDate')"
                [minType]="formPageConfig.isEditMode ? 'unlimited' : 'today'"
                (onErrorDatePicker)="showErrorDialog($event)"
              >
              </datepicker>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
